'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024149 from "./presto.types$-Restricted-Domain-Name$$anon$149.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024150 from "./presto.types$-Restricted-Domain-Name$$anon$150.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RestrictedDomainName$() {
  this.c9N = null;
  this.c9O = false;
  this.c9L = null;
  this.c9M = false;
  this.c9R = null;
  this.c9S = false;
  this.c9P = null;
  this.c9Q = false;
  this.c9T = null;
  this.c9U = false;
}
export { $c_Lpresto_types$RestrictedDomainName$ as $c_Lpresto_types$RestrictedDomainName$ };
$p = $c_Lpresto_types$RestrictedDomainName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RestrictedDomainName$;
/** @constructor */
function $h_Lpresto_types$RestrictedDomainName$() {
}
export { $h_Lpresto_types$RestrictedDomainName$ as $h_Lpresto_types$RestrictedDomainName$ };
$h_Lpresto_types$RestrictedDomainName$.prototype = $p;
$p.cJf = (function() {
  if ((!this.c9O)) {
    this.c9N = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c9O = true;
  }
  return this.c9N;
});
$p.Tj = (function() {
  if ((!this.c9M)) {
    this.c9L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c9M = true;
  }
  return this.c9L;
});
$p.aed = (function() {
  if ((!this.c9S)) {
    this.c9R = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c9S = true;
  }
  return this.c9R;
});
$p.cJC = (function() {
  if ((!this.c9Q)) {
    this.c9P = new $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024149.$c_Lpresto_types$RestrictedDomainName$$anon$149(this);
    this.c9Q = true;
  }
  return this.c9P;
});
$p.cK8 = (function() {
  if ((!this.c9U)) {
    this.c9T = new $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024150.$c_Lpresto_types$RestrictedDomainName$$anon$150(this);
    this.c9U = true;
  }
  return this.c9T;
});
var $d_Lpresto_types$RestrictedDomainName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RestrictedDomainName$, "presto.types$RestrictedDomainName$", ({
  a17: 1,
  D: 1
}));
export { $d_Lpresto_types$RestrictedDomainName$ as $d_Lpresto_types$RestrictedDomainName$ };
var $n_Lpresto_types$RestrictedDomainName$;
function $m_Lpresto_types$RestrictedDomainName$() {
  if ((!$n_Lpresto_types$RestrictedDomainName$)) {
    $n_Lpresto_types$RestrictedDomainName$ = new $c_Lpresto_types$RestrictedDomainName$();
  }
  return $n_Lpresto_types$RestrictedDomainName$;
}
export { $m_Lpresto_types$RestrictedDomainName$ as $m_Lpresto_types$RestrictedDomainName$ };
//# sourceMappingURL=presto.types$-Restricted-Domain-Name$.js.map
